import React, { useState } from "react";
import { toast } from "react-toastify";
import "./ContactContent.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelopeOpenText,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { CONTACT_INFO } from "../constants/contact";
import { sendTelegramMessage } from "../utils/telegram";

const INITIAL_FORM_DATA = {
  name: "",
  email: "",
  message: "",
};

const CONTACT_LINKS = [
  {
    href: `mailto:${CONTACT_INFO.email}`,
    icon: faEnvelopeOpenText,
    text: CONTACT_INFO.email,
  },
  {
    href: CONTACT_INFO.phoneHref,
    icon: faPhone,
    text: CONTACT_INFO.phoneDisplay,
  },
  ...CONTACT_INFO.addresses.map(({ label, mapsUrl }) => ({
    href: mapsUrl,
    icon: faLocationDot,
    text: label,
    external: true,
  })),
];

function ContactContent() {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const message = `
📩 *New Contact Message*
👤 *Name:* ${formData.name}
📧 *Email:* ${formData.email}

💬 *Message:*
${formData.message}
    `.trim();
    try {
      await sendTelegramMessage(message);
      toast.success("Message sent successfully!");
      setFormData(INITIAL_FORM_DATA);
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        error?.message || "Failed to send message. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact_section">
      <div className="contact_info container" id="contact_page">
        {/* LEFT SIDE CONTACT INFO */}
        <div className="contact_request col-lg-5">
          <div className="contact_info_title">
            <h2>How can we help you?</h2>
            <p>
              It’s easier to reach your goals when you have the right people
              behind. Get in touch today.
            </p>
          </div>

          <div className="contact_links">
            {CONTACT_LINKS.map(({ href, icon, text, external }) => (
              <div className="contact_link" key={href}>
                <a
                  href={href}
                  {...(external
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : {})}
                >
                  <FontAwesomeIcon className="contact_link_icon" icon={icon} />
                  <span>{text}</span>
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE CONTACT FORM */}
        <div className="contact_email col-lg-5">
          <form className="contact_form" onSubmit={handleSubmit}>
            <h3>Contact Us</h3>
            <p>
              We'd love to hear from you. Fill out the form and we'll be in
              touch shortly.
            </p>

            <div className="form_group">
              <input
                className="name_input"
                type="text"
                name="name"
                required
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            <div className="form_group">
              <input
                type="email"
                name="email"
                required
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="form_group">
              <textarea
                name="message"
                rows="5"
                required
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <button
              type="submit"
              className="send_btn"
              disabled={loading}
              aria-busy={loading}
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>

      {/* MAP */}
      <div className="location container" id="contact_map">
        <p>Our Location</p>
        <iframe
          src="https://www.google.com/maps/embed?pb=..."
          width="600"
          height="450"
          loading="lazy"
          title="Artel Logistics office location"
        ></iframe>
      </div>
    </div>
  );
}

export default ContactContent;
